<template>
    <div class="userinfo">
        <el-form ref="form" :model="form" label-width="80px" :rules="rules">
            <el-form-item label="真实姓名" prop="realName">
                <el-input v-model="form.realName"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="userPhone">
                <el-input :value="form.userPhone" disabled></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="companyName">
                <el-input v-model="form.companyName"></el-input>
            </el-form-item>
            <el-form-item label="公司地址" prop="companyAddress">
                <el-input v-model="form.companyAddress"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="success" @click="onSubmit">保存</el-button>
                <el-button @click="resetForm('form')">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import * as apis from '../../fetch/user';

export default {
    name: 'userinfo',
    data() {
        return {
            form: {
                realName: '',
                companyName: '',
                userPhone: '',
                companyAddress: '',
            },
            rules: {
                realName: [{ required: true, message: '请输入真实姓名', trigger: 'blur' }],
                userPhone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
                companyName: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                companyAddress: [{ required: true, message: '请输入公司地址', trigger: 'blur' }],
            },
        };
    },
    methods: {
        onSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    apis.setUserInfo(this.form).then(res => {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                        });
                    });
                }
            });
        },
        resetForm(formName) {
            const userPhone = this.form.userPhone;
            this.$refs[formName].resetFields();
            this.form.userPhone = userPhone;
        },
        getUserInfo() {
            apis.getUserInfo().then(res => {
                this.form = res;
            });
        },
    },
    mounted() {
        this.getUserInfo();
    },
};
</script>

<style lang="less" scoped>
</style>